export const CONNECT_CLIENT = 'CONNECT_CLIENT';
export const PING_CLIENT = 'PING_CLIENT';
export const DISCONNECT_CLIENT = 'DISCONNECT_CLIENT';
export const NOTIFY_CLIENT_TYPYING_STATE = 'NOTIFY_CLIENT_TYPYING_STATE';

/**
 * @returns {{payload: {}, type: string}}
 */
export const connectClient = ({ workerTime }) => ({
  type: CONNECT_CLIENT,
  payload: { workerTime }
});

/**
 * @param {{ workerTime: number }} props
 * @returns {{payload: {workerTime: number}, type: string}}
 */
export const pingClient = ({ workerTime }) => ({
  type: PING_CLIENT,
  payload: { workerTime }
});

/**
 * @param {{ workerTime: number }} props
 * @returns {{payload: {workerTime: number}, type: string}}
 */
export const disconnectedClient = ({ workerTime }) => ({
  type: DISCONNECT_CLIENT,
  payload: { workerTime }
});

/**
 * @param {{ requestId: number, isTypying: boolean }} props
 * @returns {{payload: {requestId: number, isTypying: boolean}, type: string}}
 */
export const notifyClientTypyingState = ({ requestId, isTypying }) => ({
  type: NOTIFY_CLIENT_TYPYING_STATE,
  payload: {
    requestId,
    isTypying
  }
});
